import { render, staticRenderFns } from "./AssessmentDetails.vue?vue&type=template&id=07b4b415&scoped=true"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDetails.vue?vue&type=style&index=0&id=07b4b415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b4b415",
  null
  
)

export default component.exports